import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';

interface QuantityButtonProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const QuantityButton: React.FC<QuantityButtonProps> = observer(({ restaurantOfferStore }) => {
    const { orderFoodRequest, increaseQuantity, decreaseQuantity } = restaurantOfferStore;

    const { quantity } = orderFoodRequest;
    return (
        <Paper
            elevation={3}
            sx={{
                width: "30%",
                bgcolor: "#f9f9f9",
                zIndex: 1,
                mr: 2
            }}>
            <Box display={"flex"} width={"100%"} height={"100%"} justifyContent={"space-around"} alignItems={"center"}>
                <IconButton onClick={decreaseQuantity} disabled={quantity === 1}>
                    <RemoveIcon
                        sx={{
                            fontSize: 25
                        }}

                        color={quantity === 1 ? "disabled" : "secondary"} />
                </IconButton>

                <Typography fontWeight={600}>{orderFoodRequest.quantity}</Typography>

                <IconButton onClick={increaseQuantity} disabled={quantity === 20}>
                    <AddIcon
                        sx={{
                            fontSize: 25
                        }}
                        color={quantity === 20 ? "disabled" : "secondary"} />
                </IconButton>

            </Box>
        </Paper>

    )
})

export default QuantityButton;